// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../../@types/react-modal/react-modal.d.ts" />
import { _ as _call_super } from "@swc/helpers/_/_call_super";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React, { useEffect } from "react";
import ReactModal from "react-modal";
import ModalPortal from "react-modal/lib/components/ModalPortal";
import { useTheme } from "styled-components";
import { getWindow } from "../../../common/globals/getWindow";
import { initializeReactModal } from "./reactModal";
// ModalPortal is the content of the portal in the modal by default. It does
// not render a portal.
var SSRSafeModal = /*#__PURE__*/ function(ModalPortal) {
    "use strict";
    _inherits(SSRSafeModal, ModalPortal);
    function SSRSafeModal() {
        _class_call_check(this, SSRSafeModal);
        var _this;
        _this = _call_super(this, SSRSafeModal, arguments);
        _this.state = {
            isOpen: _this.props.isOpen,
            afterOpen: false,
            beforeClose: false
        };
        return _this;
    }
    return SSRSafeModal;
}(ModalPortal);
export var BaseModal = function(_param) {
    var primary = _param.primary, isOpen = _param.isOpen, onRequestClose = _param.onRequestClose, children = _param.children, style = _param.style, _param_shouldCloseOnEsc = _param.shouldCloseOnEsc, shouldCloseOnEsc = _param_shouldCloseOnEsc === void 0 ? true : _param_shouldCloseOnEsc, _param_shouldCloseOnOverlayClick = _param.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _param_shouldCloseOnOverlayClick === void 0 ? true : _param_shouldCloseOnOverlayClick, _param_noPortal = _param.noPortal, noPortal = _param_noPortal === void 0 ? false : _param_noPortal, otherProps = _object_without_properties(_param, [
        "primary",
        "isOpen",
        "onRequestClose",
        "children",
        "style",
        "shouldCloseOnEsc",
        "shouldCloseOnOverlayClick",
        "noPortal"
    ]);
    var _theme_modals;
    var theme = useTheme();
    useEffect(function() {
        if (isOpen && noPortal) {
            var _getWindow_document_getElementById, _getWindow_document_getElementById1, _getWindow_document, _getWindow;
            (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_document = _getWindow.document) === null || _getWindow_document === void 0 ? void 0 : (_getWindow_document_getElementById1 = _getWindow_document.getElementById) === null || _getWindow_document_getElementById1 === void 0 ? void 0 : (_getWindow_document_getElementById = _getWindow_document_getElementById1.call(_getWindow_document, "main")) === null || _getWindow_document_getElementById === void 0 ? void 0 : _getWindow_document_getElementById.setAttribute("aria-hidden", "true");
        }
        return function() {
            var _getWindow_document_getElementById, _getWindow_document_getElementById1, _getWindow_document, _getWindow;
            (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_document = _getWindow.document) === null || _getWindow_document === void 0 ? void 0 : (_getWindow_document_getElementById1 = _getWindow_document.getElementById) === null || _getWindow_document_getElementById1 === void 0 ? void 0 : (_getWindow_document_getElementById = _getWindow_document_getElementById1.call(_getWindow_document, "main")) === null || _getWindow_document_getElementById === void 0 ? void 0 : _getWindow_document_getElementById.removeAttribute("aria-hidden");
        };
    }, [
        isOpen,
        noPortal
    ]);
    useEffect(function() {
        initializeReactModal();
    }, []);
    var modalTheme = (_theme_modals = theme.modals) === null || _theme_modals === void 0 ? void 0 : _theme_modals[primary ? "primary" : "default"];
    var ModalComponent = noPortal ? SSRSafeModal : ReactModal;
    var noPortalProps = noPortal ? {
        // Implement behaviour & defaults implemented in Modal (rather than the inner ModalPortal).
        ariaHideApp: true,
        shouldFocusAfterRender: true,
        bodyOpenClassName: "ReactModal__Body--open",
        role: "dialog",
        closeTimeoutMS: 0,
        shouldCloseOnEsc: true,
        shouldCloseOnOverlayClick: true,
        overlayElement: function(props, contentEl) {
            return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({}, props), {
                children: contentEl
            }));
        },
        contentElement: function(props, children) {
            return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({}, props), {
                children: children
            }));
        },
        // Provide a warning if we are accidentally hiding the modal because it is in "main"
        overlayRef: function(overlayRef) {
            if (overlayRef) {
                var _getWindow_document_getElementById, _getWindow_document, _getWindow;
                var _getWindow_document_getElementById1;
                var appElement = (_getWindow_document_getElementById1 = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_document = _getWindow.document) === null || _getWindow_document === void 0 ? void 0 : (_getWindow_document_getElementById = _getWindow_document.getElementById) === null || _getWindow_document_getElementById === void 0 ? void 0 : _getWindow_document_getElementById.call(_getWindow_document, "main")) !== null && _getWindow_document_getElementById1 !== void 0 ? _getWindow_document_getElementById1 : undefined;
                if (appElement === null || appElement === void 0 ? void 0 : appElement.contains(overlayRef)) {
                    throw new Error('<Modal noPortal={true} /> must be rendered outside "main".');
                }
            }
        }
    } : {};
    var _modalTheme_overlay, _style_overlay, _modalTheme_background, _modalTheme_color, _style_content;
    return /*#__PURE__*/ _jsx(ModalComponent, _object_spread_props(_object_spread({}, noPortalProps, otherProps), {
        isOpen: isOpen,
        style: {
            overlay: _object_spread({
                background: (_modalTheme_overlay = modalTheme === null || modalTheme === void 0 ? void 0 : modalTheme.overlay) !== null && _modalTheme_overlay !== void 0 ? _modalTheme_overlay : "rgba(0, 0, 0, 0.6)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000
            }, (_style_overlay = style === null || style === void 0 ? void 0 : style.overlay) !== null && _style_overlay !== void 0 ? _style_overlay : {}),
            content: _object_spread({
                display: "flex",
                top: "auto",
                bottom: "auto",
                left: "auto",
                right: "auto",
                border: "none",
                borderRadius: "0",
                padding: "0",
                overflow: "auto",
                alignItems: "center",
                justifyContent: "center",
                WebkitOverflowScrolling: "unset",
                background: (_modalTheme_background = modalTheme === null || modalTheme === void 0 ? void 0 : modalTheme.background) !== null && _modalTheme_background !== void 0 ? _modalTheme_background : Core.surface.inverse,
                color: (_modalTheme_color = modalTheme === null || modalTheme === void 0 ? void 0 : modalTheme.color) !== null && _modalTheme_color !== void 0 ? _modalTheme_color : Core.text.default,
                outline: "none",
                position: "relative",
                boxShadow: modalTheme === null || modalTheme === void 0 ? void 0 : modalTheme.boxShadow
            }, (_style_content = style === null || style === void 0 ? void 0 : style.content) !== null && _style_content !== void 0 ? _style_content : {})
        },
        shouldCloseOnEsc: shouldCloseOnEsc,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        onRequestClose: onRequestClose,
        children: children
    }));
};
